<template>
	<div id="">
		<div style="padding: 0 0 ">
			<div class="p_m_t_30 overflow p_m_l_60 p_m_r_60" :style="{ height: height + 'px' }">
				<div class="list_box p_b_b" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled" >
					<div class="p_flex p_f_a  p_m_t_20 type_size_16">
						<span class="type_size_22">{{item.name}}</span>
						<span class="type_size_18 subject_color p_m_l_20">未提交</span>
					</div>
				</div>
				
				<!-- <div class="p_flex p_f_c p_m_t_20 p_m_b_20" v-if="loading">加载中...</div>
				<div class="p_m_l_20 p_m_r_20" v-if="noMore"><el-divider>没有更多了</el-divider></div> -->
			</div>
		</div>
		<pagination @get="get" :index="num"/>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';
export default {
	props:{
		height:Number
	},
	data() {
		return {
			count: [],
			loading: false,
			num:0
		};
	},
	components:{
		pagination
	},
	created(){
		this.get()
	},
	computed: {
		// noMore() {
		// 	return this.count >= 20;
		// },
		// disabled() {
		// 	return this.loading || this.noMore;
		// }
	},
	mounted() {},
	methods: {
		get(id){
			this.$request.ajax(this).post("/api_teacher/analysis_report",{
           		job_publish_id: this.$route.query.id
			}).then(res=>{
				// console.log(res)
				this.$request.ajax(this).post("/api_teacher/analysis_submit_list",{
						job_publish_id: res.data.id, //作业id
						class_level_id: res.data.class_level_id , //班id
						corrects:3,  //1 已批改 2 未批改 3 未提交
						limit:10,
						page:id?id:1
				}).then(res=>{
					// console.log(res)
					this.count=res.data.list
					this.num=parseInt(res.data.count)
				}) 
			})
		},
		// load() {
		// 	this.loading = true;
		// 	setTimeout(() => {
		// 		this.count += 2;
		// 		this.loading = false;
		// 	}, 2000);
		// },
		goDeatils(){
			this.$router.push('/AnalyseDeatil');
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/list.css';
.page_box{
	min-width: calc(1200px - 260px - 30px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/commponents/generalnot.vue